
import ArchiveTick from "../../../assets/outline/ArchiveTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArchiveTickIcon({ className, dataTestid = "ArchiveTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArchiveTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
